<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <!-- 취소 반품 내역 START -->
    <div class="section fill">
      <div class="inner">
        <div class="box_title">
          <h2>취소 내역</h2>
          <!-- <p class="guide_txt">{{ $t('views.member.returns.6706') }}</p> -->
        </div>

        <div v-if="getAccountReturnTotalCount" class="mypage_detail">
          <!-- TODO: SHOULD BE A COMPONENT -->
          <div v-for="(order, idx) in getAccountReturns" :key="idx" class="box">
            <div class="order_title">
              <dl>
                <dt>{{ $t('views.member.returns.4969') }}</dt>
                <dd>
                  <span>{{ order.orderDtime | timestamp }}</span>
                </dd>
              </dl>
              <dl>
                <dt>{{ $t('views.member.returns.6508') }}</dt>
                <dd>
                  <span class="num">{{ order.orderCd }}</span>
                </dd>
              </dl>
              <router-link
                :to="{
                  name: 'order_detail',
                  params: { id: order.orderCd, order, currentTab: 'returns' }
                }"
                class="box_btn line"
              >
                <span class="an_t">
                  취소 상세보기
                </span>
              </router-link>
            </div>
            <ul class="order_book">
              <li
                v-for="(item, itemIdx) in order.orderGoodsList"
                :key="itemIdx"
              >
                <div class="cover_wrap">
                  <router-link
                    :to="{
                      name:
                        item.bookTp === 'EBOOK'
                          ? 'library_book_detail'
                          : 'book_detail',
                      params: { id: item.bookCd }
                    }"
                    class="thum_wrap"
                  >
                    <img :src="item.thumbUrl" :alt="item.bookNm" />
                  </router-link>
                </div>
                <div class="info_wrap">
                  <h3 class="meta_title">{{ item.bookNm }}</h3>
                  <p>
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }} </span>
                    <!-- <span class="gap">/</span> -->
                    <span class="meta_tel">{{ item.isbn }}</span>
                  </p>
                  <p>
                    <span class="meta_type"> {{ item.bookTp }}</span>
                  </p>
                  <p>
                    <span class="meta_num"
                      >{{ $t('common.ui.total') }}
                      <span class="num">{{ item.units }}</span
                      >{{ $t('common.ui.bookcount') }}
                    </span>
                    <del v-if="item.couponDiscount > 0" class="list_price">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.listPrice"
                      />
                    </del>
                    <span v-if="item.couponDiscount > 0" class="percent">
                      ({{
                        Math.round(
                          ((item.listPrice - item.saleAmt) / item.listPrice) *
                            100
                        )
                      }}%
                      <span class="arrow"></span>
                      )
                    </span>
                    <span v-if="item.saleAmt">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.saleAmt"
                      />
                    </span>

                    <span v-if="!item.saleAmt">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="0"
                      />
                    </span>
                  </p>
                </div>
                <!-- <div v-show="item.menuShowYn === 'Y'" class="btn_wrap"> -->
                <!-- <div class="btn_wrap">
                  <div class="cell">
                    <p class="state_txt" :class="{ c_black: item.deliveryMsg }">
                      {{ item.deliveryMsg }}
                    </p>
                    <router-link
                      :to="{ name: 'order_tracking' }"
                      class="box_btn dull"
                    >
                      <span class="an_t">
                        {{ $t('views.member.returns.8720') }}
                      </span>
                    </router-link>
                  </div>
                </div> -->
              </li>
            </ul>
          </div>

          <!-- PAGINATION START -->
          <Pagination
            :current-page="currentPage"
            :total-count="getAccountReturnTotalCount"
            :item-per-page="returnsPerPage"
            @paginate="paginate"
          />
          <!-- PAGINATION END -->
        </div>
        <EmptyData
          v-if="getAccountReturnTotalCount === 0"
          data-tp="취소 내역"
        />
      </div>
    </div>

    <!-- ****************** -->
    <!-- CANCEL RETURN ORDER MODAL -->
    <!-- ****************** -->
    <transition name="modal-fade">
      <Modal v-if="showCancelReturnModal" @close="toggleCancelReturnModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleCancelReturnModal"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner">
            <p class="tac">{{ $t('views.member.returns.1224') }}</p>
            <!-- If order is  7 days+ old, show this -->
            <!-- No, just prevent the u -->
            <!-- <p class="tac">{{ $t('views.member.returns.8110') }}</p> -->

            <div class="btn_wrap">
              <button
                class="ModalBtn box_btn dull"
                @click="toggleCancelReturnModal"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <a class="ModalBtn box_btn" @click="cancelReturnOrder"
                ><span class="an_t">{{ $t('library.deletemodal.ok') }}</span></a
              >
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import AccountHead from '@/components/member/AccountHead.vue'
import { ACCOUNT_RETURN_GET_LIST } from '@/store/types'

import { mapGetters } from 'vuex'
import EmptyData from '../../components/common/EmptyData.vue'

export default {
  name: 'Returns',

  components: { AccountHead, EmptyData },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.$store.dispatch(ACCOUNT_RETURN_GET_LIST, {})
    })
  },
  data() {
    return {
      showCancelReturnModal: false,
      currentPage: 1,
      returnsPerPage: 10
    }
  },
  computed: {
    ...mapGetters([
      'isAccountReturnLoading',
      'getAccountReturns',
      'getAccountReturnTotalCount',
      'getCurrency'
    ])
  },
  methods: {
    toggleCancelReturnModal() {
      this.showCancelReturnModal = !this.showCancelReturnModal
    },
    cancelReturnOrder() {
      // TODO: Add action to CANCEL the return order process
    },
    paginate(page) {
      this.currentPage = page
      this.loadReturns()
    },
    loadReturns() {
      const { currentPage, returnsPerPage } = this
      this.$store.dispatch(ACCOUNT_RETURN_GET_LIST, {
        page: currentPage,
        countPerPage: returnsPerPage
      })
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
// Fix Modal buttons
.ModalBtn {
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 20px 25px !important;
  .an_t {
    font-size: 16px !important;
    line-height: 1px !important;
  }
}
.member_st .gap {
  float: none;
}
.price {
  margin-left: 8px;
  font-size: 14px !important;
  font-weight: bold;
}
.none {
  pointer-events: none;
}
.list_price {
  margin-left: 7px;
  color: #778899;
}
.percent {
  color: #778899;
  .arrow {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m8.672 4.964v1.494l-3.654 2.52-3.69-2.52v-1.494l2.988 1.926v-5.868h1.386v5.868z' fill='%23f00'/%3E%3C/svg%3E%0A");
    background-position: center center;
    background-repeat: no-repeat;
  }
}
</style>
